import { Link } from 'react-router-dom';

import styled from '@emotion/styled';

export const FilterBar = styled.div`
  display: flex;
  padding: 15px 30px;
`;

export const FilterTitle = styled.div`
  margin-right: 15px;
  line-height: 46px;
`;

export const GhostLink = styled(Link)`
  color: inherit;
  text-decoration: none;
`;

export const GhostAnchor = styled.a`
  color: inherit;
  text-decoration: none;
`;

export const BtnWrap = styled.div`
  display: inline-block;
  padding: 0 10px 10px 10px;
`;
